export const FETCH_PO_VENDORS = 'FETCH_PO_VENDORS';
export const FETCH_PO_VENDORS_SUCCESS = 'FETCH_PO_VENDORS_SUCCESS';
export const FETCH_PO_VENDORS_ERROR = 'FETCH_PO_VENDORS_ERROR';

export const FETCH_PO_VENDOR = 'FETCH_PO_VENDOR';
export const FETCH_PO_VENDOR_SUCCESS = 'FETCH_PO_VENDOR_SUCCESS';
export const FETCH_PO_VENDOR_ERROR = 'FETCH_PO_VENDOR_ERROR';

export const PO_VENDOR_CREATED = 'PO_VENDOR_CREATED';
export const PO_VENDOR_UPDATED = 'PO_VENDOR_UPDATED';
